import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { ITravelFlightAirline } from '@shared/shared/interfaces/travel-flight.interfaces';
import { ALL_AIRLINES } from 'app.config';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as fromActions from '../actions/flight-airlines.actions';

@Injectable()
export class FlightAirlinesEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  public getAllFLightAirlines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.GET_ALL_FLIGHT_AIRLINES),
      switchMap<Actions, Observable<ITravelFlightAirline[]>>(() => {
        const storedAirlines = localStorage.getItem(ALL_AIRLINES);
        return storedAirlines ? of(JSON.parse(storedAirlines)) : this.http.get(ApiEndpoint.TRAVEL_FLIGHT_AIRLINES);
      }),
      map((airlines) => {
        localStorage.setItem(ALL_AIRLINES, JSON.stringify(airlines));
        return new fromActions.GetAllFlightAirlinesSuccess(airlines);
      })
    )
  );
}
